enum KnownTranslatorKeys {
  name = 'name',
  tag = 'tag',
  avatar = 'avatar',
  route = 'route',
  offloadingEquipment = 'offloadingEquipment',
  equipment = 'equipment',
  logisticObject = 'logisticObject',
  verticalObject = 'verticalObject',
  interiorPath = 'interiorPath',
  interiorDoor = 'interiorDoor',
  staging = 'staging',
  area = 'area',
  level = 'level',
  gate = 'gate',
  zone = 'zone',
  storageArea = 'storageArea',
  company = 'company',
  manPower = 'manPower',
  manpower = 'manpower',
  code = 'code',
  description = 'description',
  plannedValue = 'plannedValue',
  contract = 'contract',
  bidStatus = 'bidStatus',
  dates = 'dates',
  delete = 'delete',
  deactivate = 'deactivate',
  activate = 'activate',
  confirmDeletion = 'confirmDeletion',
  confirmDeactivation = 'confirmDeactivation',
  confirmActivation = 'confirmActivation',
  confirmDeactivationOfTheFollowingXCompanies = 'confirmDeactivationOfTheFollowingXCompanies',
  confirmActivationOfTheFollowingXCompanies = 'confirmActivationOfTheFollowingXCompanies',
  email_noun = 'email_noun',
  phoneNumber = 'phoneNumber',
  confirmDeletionOfTheFollowingXProjectMembers = 'confirmDeletionOfTheFollowingXProjectMembers',
  confirmInvitationOfTheFollowingXProjectMembers = 'confirmInvitationOfTheFollowingXProjectMembers',
  invite = 'invite',
  confirmInvitation = 'confirmInvitation',
  confirmSettingAsNotInvitedOfTheFollowingXProjectMembers = 'confirmSettingAsNotInvitedOfTheFollowingXProjectMembers',
  confirmApprovalOfTheFollowingXProjectMembers = 'confirmApprovalOfTheFollowingXProjectMembers',
  approve = 'approve_verb',
  confirmApproval = 'confirmApproval',
  setNotInvited = 'setNotInvited',
  confirmSettingUsersAsNotInvited = 'confirmSettingUsersAsNotInvited',
  plannedCompanyManpower = 'plannedCompanyManpower',
  responsibilityCode = 'responsibilityCode',
  responsibilityDescription = 'responsibilityDescription',
  contractN = 'contractN',
  plannedValueS = 'plannedValueS',
  addCustomProjectClosures = 'addCustomProjectClosures',
  addCompany = 'addCompany',
  editCompany = 'editCompany',
  userProfileDescriptions_name = 'userProfileDescriptions.name',
  projectRoles = 'projectRoles',
  globalRole = 'globalRole',
  userProfileDescriptions_projectRoles = 'userProfileDescriptions.projectRoles',
  phone = 'phone',
  currentPassword = 'currentPassword',
  newPassword = 'newPassword',
  confirmNewPassword = 'confirmNewPassword',
  role = 'role',
  status = 'status',
  inviteStatus = 'inviteStatus',
  accountType = 'accountType',
  projectTrades = 'projectTrades',
  teams = 'teams',
  accountPosition = 'accountPosition',
  editUsers = 'editUsers',
  gantt = 'gantt',
  schedule = 'schedule',
  home = 'home',
  presentationModeDescriptions_gantt = 'presentationModeDescriptions.gantt',
  deliveries = 'deliveries',
  presentationModeDescriptions_deliveries = 'presentationModeDescriptions.deliveries',
  logistics = 'logistics',
  forms = 'forms',
  presentationModeDescriptions_logistics = 'presentationModeDescriptions.logistics',
  viewName = 'viewName',
  basemap = 'basemap',
  numObjects = 'numObjects',
  geoReferencing = 'geoReferencing',
  companyName = 'companyName',
  logo = 'logo',
  companyType = 'companyType',
  responsibleUser = 'responsibleUser',
  type = 'type',
  manufacturer = 'manufacturer',
  fuel_type = 'fuel_type',
  bid_package = 'bid_package',
  assembly = 'assembly',
  members = 'members',
  addUser = 'addUser',
  options = 'options',
  selectActivityGroups = 'selectActivityGroups',
  numberOfBands = 'numberOfBands',
  none = 'none',
  workBreakdownStructureWbs = 'workBreakdownStructureWbs',
  locationBreakdownStructureLbs = 'locationBreakdownStructureLbs',
  companies = 'companies',
  lbs = 'lbs',
  date = 'date',
  seeXActivities = 'seeXActivities',
  seeXDeliveries = 'seeXDeliveries',
  seeXUsers = 'seeXUsers',
  seeXObjects = 'seeXObjects',
  seeXSitemaps = 'seeXSitemaps',
  seeXForms = 'seeXForms',
  xForms = 'xForms',
  seeXClosures = 'seeXClosures',
  seeXLogistics = 'seeXLogistics',
  seeXReports = 'seeXReports',
  seeXAttachments = 'seeXAttachments',
  seeXSensors = 'seeXSensors',
  seeXMaterials = 'seeXMaterials',
  xActivities = 'xActivities',
  xDeliveries = 'xDeliveries',
  xWorkflows = 'xWorkflows',
  dateRangeForRecentlyUpdatedActivities = 'dateRangeForRecentlyUpdatedActivities',
  whitelistedDomains = 'whitelistedDomains',
  device = 'device',
  lastReading = 'lastReading',
  firstReading = 'firstReading',
  location = 'location',
  scannerName = 'scannerName',
  building = 'building',
  truckSize = 'truckSize',
  material = 'material',
  vendor = 'vendor',
  duration = 'duration',
  inspection = 'inspection',
  cancelationReason = 'cancelationReason',
  all = 'all',
  day = 'day',
  week = 'week',
  month = 'month',
  materialsCategory = 'materialsCategory',
  materialDescription = 'materialDescription',
  plannedInstallLocation = 'plannedInstallLocation',
  plannedDeliveryLocation = 'plannedDeliveryLocation',
  currentLocation = 'currentLocation',
  employeeIDNumber = 'employeeIDNumber',
  category = 'category',
  isActive = 'isActive',
  createdBy = 'createdBy',
  project = 'project',
  fileType = 'fileType',
  uploadedBy = 'uploadedBy',
  source = 'source',
  workflowId = 'workflowId',
  workflowType = 'workflowType',
  workflowCategory = 'workflowCategory',
  workflowTitle = 'workflowTitle',
  workflowStatus = 'workflowStatus',
  fileCategory = 'fileCategory',
  sortBy = 'sortBy',
  dateUploaded = 'dateUploaded',
  dateTime = 'dateTime',
  resourcePropertyText = 'resourcePropertyText',
  resourcePropertyNumber = 'resourcePropertyNumber',
  resourcePropertySelect = 'resourcePropertySelect',
  resourcePropertyHierarchy = 'resourcePropertyHierarchy',
  resourcePropertyCheckbox = 'resourcePropertyCheckbox',
  resourcePropertyDatetime = 'resourcePropertyDatetime',
  resourcePropertyRelation = 'resourcePropertyRelation',
  resourcePropertyLocation = 'resourcePropertyLocation',
  resourcePropertyRollup = 'resourcePropertyRollup',
  resourcePropertyComputed = 'resourcePropertyComputed',
  resourcePropertyFile = 'resourcePropertyFile',
  uploadFiles = 'uploadFiles',
  maxFilesReached = 'maxFilesReached',
  fileTooLarge = 'fileTooLarge',
  fileTypeNotAllowed = 'fileTypeNotAllowed',
  uploading = 'uploading',
  associatedProperties = 'associatedProperties',
  yes = 'yes',
  no = 'no',
  failedToSaveChangesTryAgain = 'failedToSaveChangesTryAgain',
  failedToLoadUsageData = 'failedToLoadUsageData',
}

export default KnownTranslatorKeys
